import { FileText, Paperclip, X } from "lucide-react";

export const fileUrl = (id) => `${process.env.REACT_APP_BACKEND_URL}/api/files/${id}`;

export const Attachments = ({ files, compact = false }) => {
  const list = Array.isArray(files) ? files : [];
  if (!list.length) return null;
  return (
    <div className={`mt-2 grid gap-2 ${list.length > 1 ? "grid-cols-2" : "grid-cols-1"}`}>
      {list.map((f) => (f.content_type?.startsWith("image/") ? (
        <a key={f.file_id} href={fileUrl(f.file_id)} target="_blank" rel="noreferrer" data-testid={`attachment-${f.file_id}`} className="block overflow-hidden rounded-xl border border-slate-200 bg-surface-deep">
          <img src={fileUrl(f.file_id)} alt={f.name} loading="lazy" className={`w-full object-cover ${compact ? "aspect-[4/3] max-h-56" : "aspect-[4/3]"}`} />
        </a>
      ) : (
        <a key={f.file_id} href={fileUrl(f.file_id)} target="_blank" rel="noreferrer" data-testid={`attachment-${f.file_id}`} className="flex items-center gap-2.5 rounded-xl border border-slate-200 bg-surface-2 px-3 py-2.5 text-sm hover:border-gold-400/60">
          <span className="grid place-items-center w-9 h-9 shrink-0 rounded-lg bg-brand/20 text-rose-600"><FileText className="w-4 h-4" /></span>
          <span className="min-w-0"><span className="block truncate font-semibold text-slate-800">{f.name}</span><span className="block text-xs text-slate-500">PDF · {Math.max(1, Math.round((f.size || 0) / 1024))} KB</span></span>
        </a>
      )))}
    </div>
  );
};

export const FilePicker = ({ files, setFiles, max = 6, id = "file-picker" }) => (
  <div className="flex flex-wrap items-center gap-2">
    <label data-testid={`${id}-button`} className="inline-flex items-center gap-1.5 h-9 rounded-full border border-slate-200 px-3 text-xs font-semibold text-slate-700 cursor-pointer hover:border-gold-400/60 hover:text-white">
      <Paperclip className="w-3.5 h-3.5" />Photo / PDF
      <input data-testid={`${id}-input`} type="file" multiple accept="image/*,application/pdf" className="hidden"
        onChange={(e) => { setFiles((f) => [...f, ...Array.from(e.target.files ?? [])].slice(0, max)); e.target.value = ""; }} />
    </label>
    {files.map((f, i) => (
      <span key={`${f.name}-${i}`} className="inline-flex items-center gap-1 rounded-full bg-gold-400/15 border border-gold-400/40 pl-3 pr-1 h-8 text-xs text-gold-300 max-w-[12rem]">
        <span className="truncate">{f.name}</span>
        <button type="button" data-testid={`${id}-remove-${i}`} onClick={() => setFiles((fs) => fs.filter((_, j) => j !== i))} aria-label="Remove file" className="grid place-items-center w-6 h-6 rounded-full hover:bg-white/10"><X className="w-3 h-3" /></button>
      </span>
    ))}
  </div>
);
